// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Oah00lf8cycj6dRFK6Dah"};